import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Icon8 from "../../../../../assets/images/png/courses/icons/icon8.svg";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/liyide.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";

export const securityEngineeringAfrica = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Security Engineering Bootcamp",
  description: `
  This program will equip you with the fundamental skills essential for a successful career as a 
  Security Engineer. With a specific emphasis on safeguarding computer systems, networks, 
  applications, and infrastructure, you will develop expertise in defending organizations 
  against security threats and attacks. By mastering these foundational skills, you will 
  be well-prepared to ensure the resilience and integrity of company assets in the face 
  of evolving cybersecurity challenges.
    `,
  duration: "3 Months",

  //   downloadBrochureUrl:
  //     "https://drive.google.com/file/d/1psPA2EFEigkffYS2m0zqDXaApHrT3jbn/view",

  courseFormUrl: "courses/security-engineering-bootcamp/fill-form",

  jobTitle: "Security Engineering",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: Testimony2,
    name: "Ajibola Liyide",
    role: "Internal, External and Media Relations",
    testimony: `
    The Utiva training with Utiva has been challenging and inspiring. 
    Challenging because it is at the same time as the re-branding project in 
    my office. Inspiring because I have learnt a lot so far. The key point 
    is that the user experience is the most important factor to add value and 
    provide solutions. `,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Become a Security Engineer`,
    desc: `
    The global demand for Security Engineer is growing so fast and Utiva’s learning program is designed to help you get into this space. 
    In this program, you'll gain expertise in evaluating, preserving, and overseeing the safety of computer systems.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Security Engineering Fundamentals",
      unitTag: "",
      unitDescription: `
      In this course, you will be introduced to the fundamental principles and 
      practices of security engineering. These principles and properties serve 
      as the foundation for security engineers to assess, prioritize, and effectively 
      communicate security topics. Furthermore, you will explore the practical applications 
      of cryptography, understanding how it is implemented in real-world scenarios. Additionally, 
      you will delve into strategies for evaluating risk, conducting security reviews, and 
      performing audits to ensure robust security measures are in place. Through this comprehensive 
      course, you will acquire the knowledge and skills necessary to excel in the field of 
      security engineering.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "TimeSheets",
          featureDescription: (
            <>
              Your organisation logs timesheets using a proprietary programme
              named TimeSheets. This unique application was created in-house.
              This application was previously only accessible over the internal
              company network. Shortly after exposing TimeSheets to the outside
              world, the IT and security operations teams began to notice
              strange TimeSheet behaviour. IT has observed a considerable number
              of users reporting inaccurate data in the system. The security
              operations centre has detected logins from unusual locations and
              times. Unauthorised logins were discovered after filing an
              incident.
              <br />
              <br />
              After the situation was resolved, your team was asked to come in
              and evaluate the application and make recommendations. A senior
              security engineer on your team completed the incident's initial
              threat model. Your colleague uncovered the core cause of the
              event, as well as numerous more vulnerabilities, all of which are
              related to encryption, during the threat model. Your colleague has
              asked you to finish their task because they have other
              obligations.
            </>
          ),
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "System Security",
      unitTag: "",
      unitDescription: `
      Embark on a journey to explore the foundations of system security and its practical 
      implementation within the operating system realm in this course. Gain insights into 
      the vital aspects of authentication and authorization as crucial safeguards for protecting 
      data and services from unauthorized access. Discover techniques to detect and respond to 
      unauthorized system modifications effectively. Moreover, you will develop the skills to 
      construct robust logging, monitoring, and auditing tools capable of promptly detecting and 
      addressing system security breaches in real-world scenarios. By the course's conclusion, 
      you will possess the knowledge and abilities to fortify system security and respond adeptly 
      to security threats.
        `,

      unitFeatures: [
        {
          featureIcon: Icon4,
          featureTitle: "Responding to a Nation-State Cyber Attack",
          featureDescription: `South Moi is a peaceful and technologically advanced little island nation. 
          North Udan launches a cyber attack on their nuclear reactor plant in order to sabotage their 
          advanced research on creating renewable energy utilising Tridanium. Your objective will be to 
          apply what you've learned in class to investigate a Linux virtual image retrieved from a 
          compromised server during North Moi's cyber espionage effort. By developing scanning, 
          monitoring, and auditing tools, you will endeavour to identify the infection chain as 
          well as assess and improve the system's resilience against harmful attacks.
              `,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Infrastructure Security",
      unitTag: ``,
      unitDescription: `
      This course serves as an introduction to the industry's most effective practices for security 
      configurations and controls. You will engage in an assessment encompassing security benchmarks, 
      configurations, and controls. Additionally, you will conduct vulnerability scans on key infrastructure 
      operating systems and generate a comprehensive report based on a real-world industry scenario. By the 
      course's conclusion, you will possess familiarity with industry terminology, as well as a solid 
      understanding of security best practices. Furthermore, you will have the proficiency to execute 
      vulnerability scans and generate industry-standard reports, enabling you to contribute to the 
      establishment of robust security measures.
          `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle:
            "Adversarial Resilience: Assessing Infrastructure Security",
          featureDescription: `FrancoTech recently bought the Nuggets Inc firm. We must consider whether or 
          not Nuggets Inc technologies should be incorporated into FrancoTech's larger network and 
          infrastructure. Your objective will be to compare CIS Benchmarks at Nuggets Inc to Windows and 
          Linux operating systems. You will also need to run a vulnerability scan with Nmap and generate a 
          full report that includes all of the mandatory CIS Benchmark checks and vulnerabilities discovered 
          in these systems. Finally, based on your findings, you will provide a suggestion and determine 
          whether Nuggets Inc systems are ready to be merged into the FrancoTech expanded network.
          `,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Application Security",
      unitTag: ``,
      unitDescription: `Explore the essentials of secure web application development through this course. 
      Begin by familiarizing yourself with OWASP (Open Web Application Security Project) and its Top 10 list 
      of common vulnerabilities found in web applications. Gain insights into conducting static code scans 
      using specialized software, as well as acquiring the skills to manually test web applications. By the 
      course's conclusion, you will possess the knowledge and expertise necessary to work as a security expert, 
      actively contributing to the development team's security posture and aiding in the creation of more secure web applications.
      `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Vulnerable Web Application",
          featureDescription: `You have been employed by USociety, a fledgling company that has received reports 
          from the well-known hacking organisation fcity that their client data has been compromised. They require 
          you to determine how the attackers gained access to their system, extracted all of their customers' data, 
          and any additional security flaws in their programme. This security assessment is the company's top priority, 
          and they need your support.
          You'll need to look at some static code to help identify and prioritise all vulnerabilities, as well 
          as make recommendations on how to best mitigate these issues. You will also need to manually test the 
          susceptible web application to identify all vulnerabilities and generate documentation to assist the 
          development team in patching the code. The documentation clearly details the actions required to 
          reproduce the security issue as well as best practises to assist the development team in better understanding the issue.
          `,
        },
      ],
    },
  ],

  courseCoaches: [
    // {
    //   coachId: 1,
    //   coachImage: Instructor1,
    //   coachName: "Josiah Yahaya",
    //   coachRole: "Senior Blockchain Engineer, Dedicated.Ai",
    // },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Hands On Training",
      modelDescription:
        "Practical sessions with lots of collaboration and learnings",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Virtual Classes",
      modelDescription:
        "A 3 months experiential learning and hands-on Instructor-led virtual classes.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Peer-to-Peer Sessions",
      modelDescription:
        "Share knowledge with other fellows and gain multi-dimensional perspectives of problem-solving",
    },
  ],

  studentTestimonies: [
    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Ajibola",
      lastname: "Liyide",
      company: "Internal, External and Media Relations",
      testimony: `
        The Utiva training with Utiva has been challenging and inspiring. Challenging 
        because it is at the same time as the re-branding project in my office. Inspiring because 
        I have learnt a lot so far. The key point is that the user experience is the most 
        important factor to add value and provide solutions. 
        `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases",
    description: `
    Through the Utiva Security Engineering Bootcamp, you will learn what 
    makes competent Security Engineering and work on real-world projects 
    developed by industry experts. Every week in your Utiva Security Engineering Bootcamp classes, 
    you'll be provided with clear actionable steps to iteratively develop your 
    project. With real-world projects and immersive content built in partnership 
    with top-tier companies, you’ll master the skills companies require. 
      `,
    name: "James Miles",
    // image: PortfolioUserAvatar,
    // portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Security Engineering Bootcamp Certification",
    description: `
    Upon completing Utiva's Security Engineering Bootcamp, you'll receive an 
    industry-recognized, professional Security Engineering Program certification to 
    share with your network and showcase all that you've 
    learned. Utiva certificates are formatted for sharing on LinkedIn 
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `This program is designed to help you apply the important ML techniques for solving 
      real business problems and also help you make key data-driven decisions for business growth.  `,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};
